import React from 'react';
import { Content } from '@carbon/react';

function Technical() {
  return (
    <Content>
      <h1>Technical</h1>
      <p>This is the technical page.</p>
    </Content>
  );
}

export default Technical;